import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Code } from '@shared/models/code';
import { DatePipe } from '@angular/common';
import { Company } from '@shared/enums/company';
import Role from '@shared/constants/role';
import Roles from '@shared/constants/roles';
import Utils from '@shared/utils/utils';
import { MasterCode } from '@shared/enums/master-code';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { DialogBase } from '@routes/dialogs/dialog.base';

@Component({
  selector: 'app-zip-code-edit',
  templateUrl: './zip-code-edit.component.html',
  styleUrls: ['./zip-code-edit.component.scss']
})
export class ZipCodeEditComponent extends DialogBase implements OnInit {


  title: any;
  saveButtonLabel: any;
  id: any;
  zipCodeInfo: any;
  onboarding: any;
  showOnboarding: any;

  detailForm: FormGroup;
  zipCodeOptions;
  bpSelectGroup!: any;

  companies: Code[] = [];
  dealers: Code[] = [];


  userType = null;
  returnedCompany: string = null;
  roles: Code[] = [];
  error: any;

  pipe = new DatePipe('en-US');
  company;
  isSysAdmin;
  isDealer;
  loginCompanies = Company;
  addressData = {};
  country: any;


  get form() {
    return this.detailForm.controls;
  }

  ngOnInit(): void {
    this.company = this.authService.getCurrentCompany();
    this.country = this.authService.getCurrentCountry(this.company);
    this.setFormControls();
    this.setSelectOptions();
    this.isSysAdmin = this.authService.getRoles().filter(roles => roles.groups.includes(Role.sysAdmin))?.length > 0;
    this.isDealer = this.authService.hasType(Roles.dealer);

    if (this.zipCodeInfo) {
      if (this.onboarding) {
        this.setOnboarding();
      }
      this.title = 'Edit';
      this.saveButtonLabel = 'Update';
      this.id = this.zipCodeInfo._id;

      this.setEdit(this.zipCodeInfo);
      this.detailForm.controls['zipcode'].disable();
    }
  }

  setFormControls() {

    let defaultControls: any = {
      zipcode: [null, Validators.required],
      partner: [null, Validators.required],
    }
    const idControl = {
      _id: [null],
    }

    if (this.zipCodeInfo) {
      defaultControls = {
        ...defaultControls,
        ...idControl,
      }
    }

    this.detailForm = this.fb.group(defaultControls);
  }

  valueRedefinition(value) {
    value = {
      ...value, address: {
        address1: (document.getElementById('edit_route') as HTMLInputElement).value,
        address2: (document.getElementById('edit_address2') as HTMLInputElement).value,
        city: (document.getElementById('edit_locality') as HTMLInputElement).value,
        state: (document.getElementById('edit_administrative_area_level_1') as HTMLInputElement).value,
        zipcode: (document.getElementById('edit_postal_code') as HTMLInputElement).value,
        country: (document.getElementById('edit_country') as HTMLInputElement).value,
      }
    };
    return value;
  }

  setSelectOptions() {
    this.apiService.master.getConstant(MasterCode.B2bZipcodePartners).subscribe(res => {
      let arr = [];
      Object.keys(res).map(function (key) {
        arr.push({ ['code']: res[key], ['name']: res[key] })
        return arr;
      });
      this.zipCodeOptions = arr;
    });
  }


  async submitForm($event) {
    $event.stopPropagation();
    $event.preventDefault();

    let zipCodeData = this.detailForm.getRawValue();

    if (this.detailForm.invalid) {
      this.detailForm.markAllAsTouched();
      return;
    }

    this.spinnerService.start();
    this.apiService.zipCode.saveZipCode(zipCodeData)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        const messages = !this.zipCodeInfo ?
          { title: 'Zip Code Create', text: 'Zip Code created successfully' } :
          { title: 'Zip Code Update', text: 'Zip Code updated successfully' };
        Swal.fire({
          title: messages.title,
          text: messages.text,
          icon: 'success',
          allowOutsideClick: false,
        }).then((result) => {
          this.onClose.next(res);
          this.bsModalRef.hide();
        });
      }, err => Utils.showError(err));

  }

  deleteRequestedUser() {

  }

  private setEdit(userInfo) {

    const form = this.detailForm.controls;
    userInfo.updatedAt = this.pipe.transform(userInfo.auth?.updatedAt, 'shortDate');
    userInfo.createdAt = this.pipe.transform(userInfo.auth?.createdAt, 'shortDate');

    let keyRoles = null;

    Object.keys(form).forEach(key => {
      form[key].setValue(userInfo[key]);
      // if (key === 'address') {
      //   this.addressData = {
      //     address: userInfo[key]
      //   };
      // }
      // if (key === 'name') {
      //   form['name'].setValue(userInfo?.b2bCompany?.length > 0 ? userInfo.b2bCompany[0].name : '');
      // }
      // if (key === 'mainContact') {
      //   form['mainContact'].setValue(userInfo?.b2bCompany?.length > 0 ? userInfo.b2bCompany[0].tel : '');
      // }
      // if (key === 'mainEmail') {
      //   form['mainEmail'].setValue(userInfo?.b2bCompany?.length > 0 ? userInfo.b2bCompany[0].email : '');
      // }
      //
      // if (key === 'role') {
      //   form['role'].setValue(userInfo?.userType);
      // }
      //
      // if (key === 'organization') {
      //   form['organization'].setValue(userInfo?.partnerOrganization?.toUpperCase());
      // }
      //
      // if (key === 'bps') {
      //   let returnBPs = [];
      //   userInfo?.selectedBPs?.map((m) => {
      //     returnBPs.push(m.code);
      //     return m;
      //   });
      //   form['bps'].setValue(returnBPs);
      // }
      //
      // if (key === 'username') {
      //   form[key].disable();
      // }

      // Onboarding Information
      if (userInfo.onboarding) {
        /*if (key === 'requestDate') {
          form[key].setValue(DateUtils.utc2HQDate(detailInfo.onboarding.requestDate));
        }
        if (key === 'reviewedDate') {
          form[key].setValue(DateUtils.utc2HQDateTime(detailInfo.onboarding.reviewedDate));
        }*/
        if (key === 'rejectReason') {
          form[key].setValue(userInfo.onboarding.rejectReason);
        }
        /*if (key === 'reviewedBy') {
          form[key].setValue(detailInfo.onboarding.reviewedBy);
        }
        if (key === 'requestStatus') {
          form[key].setValue(detailInfo.onboarding.status);
        }*/
      }
      console.log('this.showOnboarding =', this.showOnboarding);

      if (this.showOnboarding) {
        if (!['rejectReason'].includes(key)) {
          form[key].disable();
        }
      }

    });

    this.zipCodeInfo = userInfo;
  }

  private setOnboarding() {
    this.showOnboarding = true;
  }

}
